import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Popover, Avatar } from '@material-ui/core';

class ImagePopoverAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  toggleHover = event => {
      this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
      this.setState({anchorEl: null});
  };

  render () {
    const { anchorEl } = this.state;
    const { src } = this.props;
    const open = Boolean(anchorEl);

    return (
      <div onMouseLeave={this.handleClose}>
        <Avatar src={src || 'https://via.placeholder.com/300x300/000000/FFFFFF/?text=SSENSE'} onMouseEnter={this.toggleHover} />
        <Popover
          onClick={this.preventDefault}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
          }}
          transformOrigin={{
              vertical: 'top',
              horizontal: -5
          }}
        >
          <img src={src || 'https://via.placeholder.com/300x300/000000/FFFFFF/?text=SSENSE'} alt='profile' onMouseLeave={this.handleClose} />
        </Popover>
      </div>
    );
  }
} 

ImagePopoverAvatar.propTypes = {
  src: PropTypes.string
}

ImagePopoverAvatar.defaultProps = {
  src: null
};

export default ImagePopoverAvatar;